import React, { createContext, useState, useContext, useEffect } from 'react';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState('GBP'); // Default currency

    useEffect(() => {
        const savedCurrency = localStorage.getItem('appCurrency');
        if (savedCurrency) {
            setCurrency(savedCurrency);
        }
    }, []);

    const changeCurrency = (newCurrency) => {
        setCurrency(newCurrency);
        localStorage.setItem('appCurrency', newCurrency);
    };

    const currencySymbols = {
        GBP: '£',
        INR: '₹',
    };

    return (
        <CurrencyContext.Provider value={{ currency, changeCurrency, symbol: currencySymbols[currency] }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};
